var map = {
	"./2d.json": 2468,
	"./3d.json": 2469,
	"./3dplant.json": 2470,
	"./rules.json": 1205
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings ^\.\/.*\.json$
// module id = 2467
// module chunks = 0